import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LucideIconInput } from '@lucide/angular';
import { IconComponent } from '../icon/icon.component';

export type PillColor = 'neutral' | 'accent' | 'green' | 'coral' | 'amber' | 'sky' | 'violet' | 'pink' | 'lemon';
export type PillSize = 's' | 'm';

@Component({
  selector: 'ptl-pill',
  standalone: true,
  imports: [NgClass, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="ptl-pill" [ngClass]="[color(), size()]" [class.active]="active()">
      @if (icon()) {
        <ptl-icon [icon]="icon()" size="xs"></ptl-icon>
      }
      <ng-content></ng-content>
      @if (count() !== null && count() !== undefined) {
        <span class="ptl-pill-count">{{ count() }}</span>
      }
    </span>
  `,
  styleUrls: ['./ptl-pill.component.scss'],
})
export class PtlPillComponent {
  color = input<PillColor>('neutral');
  size = input<PillSize>('m');
  icon = input<LucideIconInput>();
  active = input(false);
  count = input<number | null>(null);
}
